import { Component, Input, OnInit, Type, ViewChild } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import { Banniere, BanniereService } from '@helvetia/components'
import { Market } from 'src/app/models/market'
import { Documents } from 'src/app/models/documents'
import { TypeSupport } from 'src/app/models/type-support'
import { MarketService } from 'src/app/services/market.service'
import { TypeSupportService } from 'src/app/services/type-support.service'
import { ModalInfoComponent } from '../modal-info/modal-info.component'
import { DocumentService } from 'src/app/services/document.service'
import { trigger, state, style, transition, animate } from '@angular/animations'
import { DataSource } from '@angular/cdk/collections'
import { Observable, of } from 'rxjs'

@Component({
  selector: 'app-market',
  templateUrl: './market.component.html',
  styleUrls: ['./market.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('10ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class MarketComponent implements OnInit {

  idMarket: number
  market: any
  listTypeSupport: TypeSupport[] = []
  typeSupportToUpload: any
  badDocumentFormat = false

  displayedColumns = ['typeSupport']
  dataSource: any

  expandedElement: any
  isExpandedElements: boolean[] = []
  isExpansionDetailRow = (i: number, row: any) => row.hasOwnProperty('detailRow')

  constructor(public router: Router,
    public typeSupportService: TypeSupportService,
    public dialog: MatDialog,
    public marketService: MarketService,
    public documentService: DocumentService,
    public banniereService: BanniereService
  ) {
    this.idMarket = parseInt(window.location.pathname.split('/').slice(-1)[0])
  }

  ngOnInit(): void {
    if (!isNaN(this.idMarket)) {
      this.marketService.getMarketById(this.idMarket).subscribe(
        (market) => {
          this.market = market
        }
      )

      this.typeSupportService.getTypeSupportByIdMarket(this.idMarket).subscribe(
        (typeSupports) => {
          this.listTypeSupport = typeSupports
          this.dataSource = new ListTypeSupportDataSource(this.listTypeSupport)
          for (let i = 1; i < this.listTypeSupport.length; i++) {
            this.isExpandedElements[i] = false
          }
        }
      )
    }
  }

  isExpandedElement(index: number) {
    return this.isExpandedElements[Math.floor(index / 2)]
  }

  setExpandedElement(index: number) {
    this.isExpandedElements[Math.floor(index / 2)] = !this.isExpandedElements[Math.floor(index / 2)]
  }

  createTypeSupport() {
    this.router.navigate(['type-support/creation/' + this.market.id])
  }

  editTypeSupport(idTypeSupport: number) {
    this.router.navigate(['type-support/edition/' + idTypeSupport])
  }

  addDocument(typeSupportToUpload: any) { 
    this.typeSupportToUpload = typeSupportToUpload
    const element: HTMLElement = document.getElementById('filesInput') as HTMLElement
    element.click()
  }

  onFileChange(event: any) {
    this.badDocumentFormat = false
    const fd = new FormData()
    const files = event.target.files
    
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        let idxDot = files[i].name.lastIndexOf(".") + 1
        let extFile = files[i].name.substr(idxDot, files[i].name.length).toLowerCase();
        if (extFile == "jpg" || extFile == "jpeg" || extFile == "png" || extFile == "gif" || extFile == "xlsx" || extFile == "xlsm" || extFile == "xls" 
          || extFile == "csv" || extFile == "pdf" || extFile == "mp4") {
          fd.append('Files', files[i])
        } else {
          this.badDocumentFormat = true
          let banniere = new Banniere()
          banniere.text = 'Certains documents n\'ont pas pu être téléchargés. Seuls les fichiers images, pdf, excel et mp4 sont autorisés'
          banniere.status = 'error'
          this.banniereService.setStatus(banniere)
        }
      }
      fd.append('SupportId', this.typeSupportToUpload.id)

      if (fd.get('Files')) {
        this.documentService.uploadDocument(fd).subscribe(
          (data) => {
            if (!this.badDocumentFormat && data.duplicateDocument.length === 0) {
              let banniere = new Banniere()
              banniere.text = 'L\'ajout de document(s) s\'est bien passé !'
              banniere.status = 'success'
              this.banniereService.setStatus(banniere)
            }
            this.typeSupportToUpload.documents = data.documents.value
            this.typeSupportToUpload.nbDocument = data.documents.value.length
            if (data.duplicateDocument.length > 0) {
              let banniere = new Banniere()
              banniere.text = 'Téléchargement impossible pour certains documents car ils existent déjà pour ce type de support'
              banniere.status = 'error'
              this.banniereService.setStatus(banniere)
            }
          }
        )
      }
    }
  }

  deleteDocument(document: Documents, element: TypeSupport) {
    const dialogRef = this.dialog.open(ModalInfoComponent, {
      data: {
        action: 'Suppression d\'un document',
        information: 'Etes-vous sûr de vouloir supprimer le document : ' + document.name
      }
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.action) {
        this.documentService.deleteDocument(document.id).subscribe(
          (data) => {
            let banniere = new Banniere()
            banniere.text = 'Le document a bien été supprimé'
            banniere.status = 'success'
            this.banniereService.setStatus(banniere)
            element.documents = data
            element.nbDocument = data.length
          }
        )
      }
    })
  }

  collapseTypeSupport(typeSupport: TypeSupport) {
    typeSupport.documents = []
  }
  
  expandTypeSupport(typeSupport: TypeSupport) {
    this.documentService.getDocumentByTypeSupportId(typeSupport.id).subscribe(
      (data) => {
        typeSupport.documents = data
      }
    )
  }
}

export class ListTypeSupportDataSource extends DataSource<any> {
  data: any

  constructor(dataUp: any) {
    super()
    this.data = dataUp
  }

  connect(): Observable<Element[]> {
    const rows: any = []
    this.data.forEach((element: any)=> rows.push(element, { detailRow: true, element }))
    return of(rows)
  }

  disconnect() { }
}
